import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ABaseComponent from "Components/Base/ABaseComponent";
import { Client, PorterViewModel, GetPorterItemListViewModel, IPorterBudget, IPorter } from 'Api/CoreApi';
import ApiProvider from 'Api/ApiProvider';
import cart from 'Store/cart/cart';
import { OrderLineComment } from 'Api/DynamicwebApi';
//import UserInformationComponent from "Components/Base/UserInformationComponent";
import PorterBugetStore from "Store/porterBudget/porterBudget";
@Component({})
export default class CartFlowTotalPriceComponent extends ABaseComponent {
    get sessionBudget() {
        return PorterBugetStore.state.porterBudget;
    }

    get sessionPorter() {
        return PorterBugetStore.state.porter;
    }

    @Prop({ default: "" })
    isPorter: boolean;

    gotData: boolean = false;

    client: Client;


    async created() {
        this.client = ApiProvider.getApiClient();

        if (this.isPorter) {
            await PorterBugetStore.dispatchFetchPorterBudget();
            //this.sessionPorter = await UserInformationComponent.getPorter();
            //await porterBudget.dispatchFetchPorterBudget({ porterContactNo: this.sessionPorter.contactNo });
            //this.sessionBudget = porterBudget.state.currentPorterBudget;
        }
    }
}

Vue.component("cart-flow-total-price-component", CartFlowTotalPriceComponent);